import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select} from "antd";
import {useModel} from "../../../models/index";

const {RangePicker} = DatePicker;
const rangeConfig = {
    rules: [{type: 'array', required: false, message: '请选择制单时间!'}],
};
export default function () {
    const [form] = Form.useForm();

    const [{stockCheckStatusDict},] = useModel("cmDict");
    const [{searchParam, checkPage}, {setSearchParam, resetSearchParam, loadCheckList}] = useModel("stockCheck");

    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam]);

    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const {pageSize, pageNum} = checkPage
        const {inventoryListCode, orderStatus} = searchParam;
        let data = {
            startTime,
            endTime,
            inventoryListCode,
            orderStatus,
            pageSize,
            pageNum
        }
        loadCheckList({showMsg: true, data});
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam();
        let data = {
            pageSize: 15,
            pageNum: 1,
        }
        loadCheckList({showMsg: true, data})

    }
    return (
        <Form
            form={form}
            name="stock_check_search"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="inventoryListCode"
                label="盘库单号"
            >
                <Input placeholder="盘库单号" style={{width: "200px"}}/>
            </Form.Item>
            <Form.Item
                name="orderStatus"
                label="状态"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择盘点状态"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={stockCheckStatusDict}
                    style={{width: "200px"}}
                />
            </Form.Item>

            <Form.Item name="checkTime" label="制单日期" {...rangeConfig}>
                <RangePicker style={{width: "300px"}}/>
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}